import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { AnalyticsRouterListener } from './analytics';
import Info from './pages/info/Info';
import TermsPanel from './pages/home/TermsPanel';
import Layout from './components/layouts/Layout';
import Conditions from './pages/conditions/Conditions';
import EmailVerification from './pages/emailVerification/Email';
import PhoneVerification from './pages/phoneVerification/Phone';
import UploadImage from './pages/uploadImage/Upload';
import ReadyImage from './pages/readyImage/Ready';
import Congratulations from './pages/congratulations/Congratulations';
import Sumsub from './pages/sumsub/Sumsub';
import HashVerify from './hashVerify/hashVerify';
import OtpVerification from './pages/otp/Otp';
import VerificationOptions from './pages/verificationOptions/VerificationOptions';
import ImIdVerification from './pages/imIdVerification/ImIdVerification';
import ImIdVerificationPending from './pages/imIdVerificationPending/ImIdVerificationPending';
import ImIdVerificationResult from './pages/imIdVerificationResult/ImIdVerificationResult';
import Error from './components/error/Error';
import RequireAccount from './pages/requireAccount/RequireAccount';
import Resume from './pages/resume/Resume';

import './i18n';

import './index.css';
import './App.scss';

function App() {
    return (
        <>
            <Router>
                <AnalyticsRouterListener />
                <Routes>
                    <Route element={<Layout />}>
                        {/* Public Routes */}
                        <Route path="/error" element={<Error />} />
                        <Route path="congratulation" element={<Congratulations />} />
                        <Route path="resume" element={<Resume />} />

                        <Route index element={<TermsPanel />} />
                        {/* Routes that require account */}
                        <Route element={<RequireAccount />}>
                            <Route path="info" element={<Info />} />
                            <Route path="conditions" element={<Conditions />} />

                            <Route path="email" element={<EmailVerification />} />
                            <Route path="phone" element={<PhoneVerification />} />
                            <Route path="verification-options" element={<VerificationOptions />} />
                            <Route path="imid-verification" element={<ImIdVerification />} />
                            <Route path="otp" element={<OtpVerification />} />
                            <Route path="sumsub" element={<Sumsub />} />
                            <Route
                                path="imid-verification-pending"
                                element={<ImIdVerificationPending />}
                            />
                            <Route
                                path="imid-verification-result"
                                element={<ImIdVerificationResult />}
                            />
                            {/* Routes that currently are not used */}
                            <Route path="upload" element={<UploadImage />} />
                            <Route path="ready" element={<ReadyImage />} />
                            <Route path="/hashVerify/:partnerId/:hash" element={<HashVerify />} />
                            {/*  */}
                        </Route>
                    </Route>

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Router>
            <ToastContainer />
        </>
    );
}

export default App;
